export default (theme) => ({
  actions: {
    display: 'flex',
    gap: theme.spacing(2),
  },
});
